export var ManualRestoreStatus;
(function (ManualRestoreStatus) {
    ManualRestoreStatus["ACTIVE"] = "ACTIVE";
    ManualRestoreStatus["EXPIRED"] = "EXPIRED";
})(ManualRestoreStatus || (ManualRestoreStatus = {}));
export class ManualRestoreModel {
    restoreAccountId;
    restoreAccountName;
    sourceAccountId;
    status;
    shippingToken;
    allowedBytes;
    usedBytes;
    createdAt;
    expiresAt;
}
export class ManualRestoreRequest {
    restoreAccountName;
    ttlInDays;
    volumeInBytes;
}
//# sourceMappingURL=manual-restore.js.map